import {
  APPLY,
  CANCEL,
  DEFAULT_TIMEBAND,
  TIMELINE,
  WAVES,
} from "../../consts/strings";
import {
  isEditOneModeSelector,
  isWaveEditModeSelector,
} from "../../reducers/matrixProfile/selectors";
import { useDispatch, useSelector } from "react-redux";

import { Grid } from "@mui/material";
import StyledChip from "../DayChips/StyledChip";
import { memo } from "react";
import { palette } from "../../theme/palette";
import { selectedTimeBandSelector } from "../../reducers/ownApp/selectors";
import { setWaveEditMode } from "../../reducers/matrixProfile/thunkActions";
import { toggleFinalRoutesMode } from "../../reducers/ownApp/thunkActions";

export const WavesControls = memo(({ newWaves, onCancel, onApply }) => {
  const isWaveEditMode = useSelector(isWaveEditModeSelector);
  const selectedTimeBand = useSelector(selectedTimeBandSelector);
  const isEditOneMode = useSelector(isEditOneModeSelector);
  const dispatch = useDispatch();

  return !!!newWaves ? (
    <StyledChip
      size={"small"}
      clickable
      disabled={isEditOneMode}
      label={isWaveEditMode ? TIMELINE : WAVES}
      onClick={() => {
        if (!isWaveEditMode && selectedTimeBand === DEFAULT_TIMEBAND) {
          dispatch(toggleFinalRoutesMode());
        }
        dispatch(setWaveEditMode(!isWaveEditMode));
      }}
      width={55}
    />
  ) : (
    <Grid container justifyContent={"space-between"}>
      <Grid item xs={6}>
        <StyledChip
          size={"small"}
          clickable
          label={CANCEL}
          onClick={() => onCancel && onCancel()}
          width={38}
          backgroundColour={palette.orange}
        />
      </Grid>
      <Grid item xs={6}>
        <StyledChip
          size={"small"}
          clickable
          label={APPLY}
          onClick={() => onApply && onApply()}
          width={35}
          backgroundColour={palette.btn.blueFill}
        />
      </Grid>
    </Grid>
  );
});
